import { Typography } from 'material-ui'
import * as React from 'react'
import { SFC } from 'react'
import { SpreadHeading } from '../components/SpreadHeading'

export const MainBlurb: SFC<{
    title: string
}> = ({title, children}) => {
    return (
        <div style={{width: '100%', maxWidth: 450}}>
            <SpreadHeading title={title}/>
            <Typography
                type='subheading'
                style={{margin: '10px 0px', color: '#505050', lineHeight: '2em'}}
            >
                {children}
            </Typography>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/stories/MainBlurb.tsx